import { createRouter, createWebHistory } from 'vue-router';
import AccountSettings from '@/components/AccountSettings';
import AccountSettingsAddEdit from '@/components/AccountSettingsAddEdit';
import AddArticle from '@/components/AddArticle';
import AddCompany from '@/components/AddCompany';
import AddUser from '@/components/AddUser';
import PackageBackOffice from '@/components/AdminPackage';
import AdminPackagesAddEdit from '@/components/AdminPackagesAddEdit';
import Billing from '@/components/Billing';
import BusinessIntelligence from '@/components/BusinessIntelligence';
import ClientInsight from '@/components/ClientInsight';
import alerts from '@/components/search/Alerts';
import document from '@/components/search/Document';
import recapEnterprise from '@/components/search/Enterprise';
import memo from '@/components/search/Memo';
import peopleSummary from '@/components/search/PeopleSummary';
import ArticleBackOffice from '@/components/tables/AdminArticleTable';
import AccountBackOffice from '@/components/tables/AdminUserTable';
import UserTable from '@/components/tables/UserTable';
import About from '@/views/About.vue';
import Alerts from '@/views/Alerts.vue';
import backOffice from '@/views/BackOffice.vue';
import CGVView from '@/views/CGV';
import Contact from '@/views/Contact';
import CookiesConditions from '@/views/CookiesConditions';
import ForcePasswordChange from '@/views/ForcePasswordChange';
import historyMonitoring from '@/views/History';
import Home from '@/views/Home.vue';
import ImportCompanies from '@/views/ImportCompanies';
import Landing from '@/views/Landing';
import Legal from '@/views/Legal';
import linkExpired from '@/views/linkExpired';
import Login from '@/views/Login.vue';
import News from '@/views/News';
import NewsList from '@/views/NewsList';
import NotFound from '@/views/NotFound.vue';
import Password from '@/views/Password.vue';
import ResultImportCompanies from '@/views/ResultImportCompanies';
import RGPDView from '@/views/RGPD';
import Search from '@/views/Search.vue';
import Settings from '@/views/Settings.vue';
import Version from '@/views/Version.vue';
import Wallet from '@/views/Wallet.vue';

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      middleware: ['auth'],
      footer: true,
      autoScroll: true,
    },
  },
  {
    path: '/alertes',
    name: 'alerts',
    component: Alerts,
    meta: {
      middleware: ['auth'],
      footer: true,
    },
  },
  {
    path: '/expiredLink',
    name: 'expiredLink',
    component: linkExpired,
    meta: {
      footer: true,
      autoScroll: true,
    },
  },
  {
    path: '/wallet',
    name: 'wallet',
    component: Wallet,
    meta: {
      middleware: ['auth'],
      footer: true,
    },
  },
  {
    path: '/search/:searchedCompanies?',
    name: 'search',
    component: Search,
    meta: {
      middleware: ['auth'],
      footer: true,
    },
    props: route => ({ id: route.params.id || '', page: route.path, default: true }),
    children: [
      {
        path: '/search/:id/enterprise',
        name: 'searchByIdEnterprise',
        component: recapEnterprise,
        meta: {
          middleware: ['auth'],
          footer: true,
        },
      },
      {
        path: '/search/:id/people',
        name: 'searchByIdPeople',
        component: peopleSummary,
        meta: {
          middleware: ['auth'],
          footer: true,
        },
      },
      {
        path: '/search/:id/documents',
        name: 'searchByIdDocuments',
        component: document,
        meta: {
          middleware: ['auth'],
          footer: true,
        },
      },
      {
        path: '/search/:id/alerts',
        name: 'searchByIdAlerts',
        component: alerts,
        meta: {
          middleware: ['auth'],
          footer: true,
        },
      },
      {
        path: '/search/:id/notes',
        name: 'searchByIdNotes',
        component: memo,
        meta: {
          middleware: ['auth'],
          footer: true,
        },
      },
    ],
  },
  {
    path: '/settings',
    component: Settings,
    meta: {
      middleware: ['auth', 'mainUser'],
      footer: true,
      autoScroll: true,
    },
    props: route => ({ page: route.path }),
    children: [
      {
        path: '',
        name: 'settings',
        redirect: { name: 'account' },
      },
      {
        path: 'account',
        name: 'account',
        component: AccountSettings,
        meta: {
          middleware: ['auth', 'mainUser'],
          footer: true,
          autoScroll: true,
        },
      },
      {
        path: 'account/add',
        name: 'accountAdd',
        component: AccountSettingsAddEdit,
        props: { isEdit: false },
        meta: {
          middleware: ['auth', 'mainUser'],
          footer: true,
          autoScroll: true,
        },
      },
      {
        path: 'account/edit',
        name: 'accountEdit',
        component: AccountSettingsAddEdit,
        props: { isEdit: true },
        meta: {
          middleware: ['auth', 'mainUser'],
          footer: true,
          autoScroll: true,
        },
      },
      {
        path: 'users',
        component: UserTable,
        meta: {
          middleware: ['auth', 'mainUser'],
          footer: true,
          autoScroll: true,
        },
      },
      {
        path: 'users/add',
        component: AddUser,
        props: { isEdit: false },
        meta: {
          middleware: ['auth', 'mainUser'],
          footer: true,
          autoScroll: true,
        },
      },
      {
        path: 'users/edit',
        component: AddUser,
        props: { isEdit: true },
        meta: {
          middleware: ['auth', 'mainUser'],
          footer: true,
          autoScroll: true,
        },
      },
      {
        path: 'billing',
        component: Billing,
        meta: {
          middleware: ['auth', 'mainUser'],
          footer: true,
          autoScroll: true,
        },
      },
    ],
  },
  {
    path: '/admin',
    component: backOffice,
    meta: {
      middleware: ['auth', 'admin'],
      footer: true,
      autoScroll: true,
    },
    props: route => ({ page: route.path }),
    children: [
      {
        path: '',
        name: 'admin',
        redirect: { name: 'adminAccount' },
      },
      {
        path: 'account',
        name: 'adminAccount',
        component: AccountBackOffice,
        meta: {
          middleware: ['auth', 'admin'],
          footer: true,
          autoScroll: true,
        },
      },
      {
        path: 'account/add',
        component: AddUser,
        props: { isEdit: false },
        meta: {
          middleware: ['auth', 'admin'],
          footer: true,
          autoScroll: true,
        },
      },
      {
        path: 'account/edit',
        component: AddUser,
        props: { isEdit: true },
        meta: {
          middleware: ['auth', 'admin'],
          footer: true,
          autoScroll: true,
        },
      },
      {
        path: 'company/add',
        component: AddCompany,
        props: { isEdit: false },
        meta: {
          middleware: ['auth', 'admin'],
          footer: true,
          autoScroll: true,
        },
      },
      {
        path: 'company/edit',
        component: AddCompany,
        props: { isEdit: true },
        meta: {
          middleware: ['auth', 'admin'],
          footer: true,
          autoScroll: true,
        },
      },
      {
        path: 'package',
        name: 'adminpackage',
        component: PackageBackOffice,
        meta: {
          middleware: ['auth', 'admin'],
          footer: true,
          autoScroll: true,
        },
      },
      {
        path: 'package/add',
        component: AdminPackagesAddEdit,
        props: { isEdit: false },
        meta: {
          middleware: ['auth', 'admin'],
          footer: true,
          autoScroll: true,
        },
      },
      {
        path: 'package/edit',
        component: AdminPackagesAddEdit,
        name: 'adminPackageEdit',
        props: { isEdit: true },
        meta: {
          middleware: ['auth', 'admin'],
          footer: true,
          autoScroll: true,
        },
      },
      {
        path: 'article',
        name: 'adminArticle',
        component: ArticleBackOffice,
        meta: {
          middleware: ['auth', 'admin'],
          footer: true,
          autoScroll: true,
        },
      },
      {
        path: 'article/add',
        component: AddArticle,
        props: { isEdit: false },
        meta: {
          middleware: ['auth', 'admin'],
          footer: true,
          autoScroll: true,
        },
      },
      {
        path: 'businessIntelligence',
        component: BusinessIntelligence,
        meta: {
          middleware: ['auth', 'admin'],
          footer: true,
          autoScroll: true,
        },
      },
      {
        path: 'businessIntelligence/:id',
        name: 'ClientInsight',
        component: ClientInsight,
        meta: {
          middleware: ['auth', 'admin'],
          footer: true,
          autoScroll: true,
        },
      },
    ],
  },
  {
    path: '/importCompanies',
    name: 'importCompanies',
    component: ImportCompanies,
    meta: {
      middleware: ['auth', 'mainUser'],
      footer: true,
      autoScroll: true,
    },
  },
  {
    path: '/history',
    component: historyMonitoring,
    props: route => ({ page: route.path }),
    meta: {
      middleware: ['auth'],
      footer: true,
      autoScroll: true,
    },
    children: [
      {
        path: '',
        name: 'history',
        redirect: { name: 'manual' },
        meta: {
          middleware: ['auth'],
          footer: true,
          autoScroll: true,
        },
      },
      {
        path: 'manual',
        name: 'manual',
        meta: {
          middleware: ['auth'],
          footer: true,
          autoScroll: true,
        },
      },
      {
        path: 'group',
        name: 'group',
        meta: {
          middleware: ['auth'],
          footer: true,
          autoScroll: true,
        },
      },
    ],
  },
  {
    path: '/ResultImportCompanies',
    name: 'ResultImportCompanies',
    component: ResultImportCompanies,
    meta: {
      middleware: ['auth'],
      footer: true,
      autoScroll: true,
    },
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      autoScroll: true,
    },
  },
  {
    path: '/force-password-change',
    name: 'ForcePasswordChange',
    component: ForcePasswordChange,
    meta: { middleware: ['auth'] },
  },
  {
    path: '/register',
    name: 'register',
    component: Password,
    props: { setPassword: true },
    meta: {
      autoScroll: true,
    },
  },
  {
    path: '/forgetPassword',
    name: 'forgetPassword',
    component: Password,
    props: { setPassword: false },
    meta: {
      autoScroll: true,
    },
  },
  {
    path: '/version',
    name: 'version',
    component: Version,
    meta: {
      autoScroll: true,
    },
  },
  {
    path: '/about',
    name: 'about',
    component: About,
    meta: {
      autoScroll: true,
    },
  },
  {
    path: '/news',
    name: 'news',
    component: NewsList,
    meta: {
      footer: true,
      autoScroll: true,
    },
  },
  {
    path: '/news/:id',
    name: 'newsId',
    component: News,
    meta: {
      footer: true,
      autoScroll: true,
    },
  },
  {
    path: '/contact',
    name: 'contact',
    component: Contact,
    meta: {
      footer: true,
      allowNoCookie: true,
    },
  },
  {
    path: '/mentions-legales',
    name: 'legal',
    component: Legal,
    meta: {
      footer: true,
      allowNoCookie: true,
    },
  },
  {
    path: '/landing',
    name: 'landing',
    component: Landing,
    meta: {
      autoScroll: true,
      footer: true,
    },
  },
  {
    path: '/cookies',
    name: 'cookies',
    component: CookiesConditions,
    meta: {
      autoScroll: true,
      footer: true,
      allowNoCookie: true,
    },
  },
  {
    path: '/cgv',
    name: 'cgv',
    component: CGVView,
    meta: {
      autoScroll: true,
      footer: true,
      allowNoCookie: true,
    },
  },
  {
    path: '/rgpd',
    name: 'rgpd',
    component: RGPDView,
    meta: {
      autoScroll: true,
      footer: true,
      allowNoCookie: true,
    },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'notFound',
    component: NotFound,
    meta: {
      autoScroll: true,
      allowNoCookie: true,
    },
  },
];

const router = createRouter({
  scrollBehavior(to) {
    if (to.meta.autoScroll) {
      window.document.querySelector('body').classList.remove('smooth');
      window.document.querySelector('html').classList.remove('smooth');
      window.scrollTo({
        top: 0,
      });
      window.document.querySelector('body').classList.add('smooth');
      window.document.querySelector('html').classList.add('smooth');
    }
  },
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

export default router;
